import { Typography } from 'antd';
import styled, { css } from 'styled-components';
import {COLORS} from "../../helpers/constants";

const { Title: TitleComponent } = Typography;

// eslint-disable-next-line no-unused-vars
export const Title = styled(({ color, ...props }) => <TitleComponent {...props} />)`
  && {
    color: ${(props) => props.color || COLORS.PRIMARY.BLACK};
    margin: 20px 0;
    font-size: 23px;
    text-align: justify;

    ${(props) =>
      props.level === 1
        ? css`
            font-weight: 700;
          `
        : ''}

    ${(props) =>
      props.level === 2
        ? css`
            font-weight: 600;
          `
        : ''}
  }
`;

export { SmallText, Text, SecondaryText, textStyles } from './text';
export { TitleSeparator } from './title-separator';
